import { createRouter, createWebHistory } from "vue-router";
import { useCookies } from "vue3-cookies";
import Home from "../views/Home.vue";
import Search from "../components/search/Search.vue";
import Categories from "../components/categories/Categories.vue";
import Category from "../components/category/Category.vue";
import PageNotFound from "../components/pages/PageNotFound.vue";
import Website from "../components/pages/Website.vue";
import Video from "../components/pages/Video.vue";
import Game from "../components/pages/Game.vue";
import Account from "../components/account/Account.vue";
import ProfileNew from "../components/profile/ProfileNew.vue";
import ProfileStart from "../components/profile/ProfileStart.vue";
import AccountFaq from "../components/account/AccountFaq.vue";
import AccountPrivacy from "../components/account/AccountPrivacy.vue";
import AccountCompetitions from "../components/account/AccountCompetitions.vue";
import AccountSettings from "../components/account/AccountSettings.vue";
import ProfileSelect from "../components/profile/ProfileSelect.vue";
import AccountOpinions from "../components/account/AccountOpinions.vue";
import Favorites from "../components/pages/Favorites.vue";
import Rules from "../components/pages/Rules.vue";
import Privacy from "../components/pages/Privacy.vue";

import store from "../store";
const { cookies } = useCookies();

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: "/start",
            name: "Home",
            component: Home,
        },
        {
            path: '/wyszukiwarka',
            name: 'Search',
            component: Search,
            query: 'query',
        },
        {
            path: "/",
            name: "Categories",
            component: Categories,
            props: true,            
        },
        {
            path: '/bajki',
            name: "Bajki",
            component: Category,
            props: { type: 'CATEGORY_WEBSITE' },     
        },
        {
            path: '/programy',
            name: "Programy",
            component: Category,
            props: { type: 'CATEGORY_WEBSITE' },               
        },
        {
            path: '/muzyka',
            name: "Muzyka",
            component: Category,
            props: { type: 'CATEGORY_AUDIO' },               
        },
        {
            path: '/sen',
            name: "Sen",
            component: Category,
            props: { type: 'CATEGORY_SLEEP' },               
        },
        {
            path: '/gry',
            name: "Game",
            component: Category,
            props: { type: 'CATEGORY_GAME' },              
        },
        {
            path: '/gry',
            name: "Gry",
            component: Category,
            props: { type: 'CATEGORY_GAME' },            
        },        
        {
            path: '/tv-online',
            name: "TV Online",
            component: Category,
            props: { type: 'CATEGORY_STREAM' },              
        },
        {
            path: '/tv-online',
            name: "Program TV",
            component: Category,
            props: { type: 'CATEGORY_STREAM' },           
        },
        {
            path: '/:id/:slug',
            name: 'Website',
            component: Website,
            beforeEnter(to) {
                let history = store.getters.getHistory;
                // fix na url generowany przez nastepny odcinek w playerze
                if(to.path && history.findIndex((el) => el.path === to.path) === -1 && window.__pageSettings.type === 'VIDEO') {
                    let str = to.path;
                    let newPath = str.substring(0, str.lastIndexOf("/")) + '/VIDEO' + str.substring(str.lastIndexOf("/"), str.length);
                    let id = str.substring(str.indexOf("/") + 1, str.lastIndexOf("/"));
                    let slug = str.substring(str.lastIndexOf("/") + 1);

                    router.push({
                        name: "Video",
                        path: newPath,
                        params: { id, slug },
                    });  
                }
            },
        },
        {
            path: '/:id/video/:slug',
            name: 'Video',
            component: Video
        },
        {
            path: '/gry/:id/:slug',
            name: 'Game',
            component: Game
        },
        {
            path: '/strefa-rodzica',
            name: 'Account',
            component: Account,
            beforeEnter() {
                var isLogged = cookies.get("TVP_MNG_SESS");
                if (!isLogged) {
                    store.dispatch("changeModalLoginState");
                    store.dispatch("changeModalBackdrop", true);

                    router.push({
                        name: "Home",
                        path: "/",
                    });                    
                }
            }             
        },
        {
            path: '/faq',
            name: 'AccountFaq',
            component: AccountFaq,
            beforeEnter() {
                var isLogged = cookies.get("TVP_MNG_SESS");
                if (!isLogged) {
                    store.dispatch("changeModalLoginState");
                    store.dispatch("changeModalBackdrop", true);

                    router.push({
                        name: "Home",
                        path: "/",
                    });                     
                }            
            }             
        },  
        {
            path: '/prywatnosc',
            name: 'AccountPrivacy',
            component: AccountPrivacy,
            beforeEnter() {
                var isLogged = cookies.get("TVP_MNG_SESS");
                if (!isLogged) {
                    store.dispatch("changeModalLoginState");
                    store.dispatch("changeModalBackdrop", true);

                    router.push({
                        name: "Home",
                        path: "/",
                    });                      
                }
            }             
        }, 
        {
            path: '/ustawienia',
            name: 'AccountSettings',
            component: AccountSettings,
            beforeEnter() {
                var isLogged = cookies.get("TVP_MNG_SESS");
                if (!isLogged) {
                    store.dispatch("changeModalLoginState");
                    store.dispatch("changeModalBackdrop", true);

                    router.push({
                        name: "Home",
                        path: "/",
                    });                       
                }
            }             
        }, 
        {
            path: '/konkursy',
            name: 'AccountCompetitions',
            component: AccountCompetitions,
            beforeEnter() {
                var isLogged = cookies.get("TVP_MNG_SESS");
                if (!isLogged) {
                    store.dispatch("changeModalLoginState");
                    store.dispatch("changeModalBackdrop", true);

                    router.push({
                        name: "Home",
                        path: "/",
                    });                       
                }
            }             
        }, 
        {
            path: '/opinie',
            name: 'AccountOpinions',
            component: AccountOpinions,
            beforeEnter() {
                var isLogged = cookies.get("TVP_MNG_SESS");
                if (!isLogged) {
                    store.dispatch("changeModalLoginState");
                    store.dispatch("changeModalBackdrop", true);

                    router.push({
                        name: "Home",
                        path: "/",
                    });                       
                }
            }             
        }, 
        {
            path: '/nowy-profil',
            name: 'ProfileNew',
            component: ProfileNew,
            beforeEnter() {
                var isLogged = cookies.get("TVP_MNG_SESS");
                if (!isLogged) {
                    store.dispatch("changeModalLoginState");
                    store.dispatch("changeModalBackdrop", true);

                    router.push({
                        name: "Home",
                        path: "/",
                    });                       
                }
            }             
        },
        {
            path: '/dodaj-profil',
            name: 'ProfileStart',
            component: ProfileStart,
            beforeEnter() {
                var isLogged = cookies.get("TVP_MNG_SESS");
                if (!isLogged) {
                    store.dispatch("changeModalLoginState");
                    store.dispatch("changeModalBackdrop, true");

                    router.push({
                        name: "Home",
                        path: "/",
                    });                       
                }
            }        
        },
        {
            path: '/wybierz-profil',
            name: 'ProfileSelect',
            component: ProfileSelect,
            beforeEnter() {
                var isLogged = cookies.get("TVP_MNG_SESS");
                if (!isLogged) {
                    store.dispatch("changeModalLoginState");
                    store.dispatch("changeModalBackdrop", true);

                    router.push({
                        name: "Home",
                        path: "/",
                    });                       
                }
            }        
        },
        {
            path: '/ulubione',
            name: 'Favorites',
            component: Favorites                
        },
        {
            path: '/regulamin',
            name: 'Rules',
            component: Rules              
        },      
        {
            path: '/polityka',
            name: 'Privacy',
            component: Privacy               
        },            
        {
            name: '404',
            path: '/:pathMatch(.*)*',
            component: PageNotFound
        }
    ],
    scrollBehavior() {
        return { top: 0 };
    }
});

router.afterEach((to) => {
    if(sessionStorage.getItem("history")) {
        let historyArr = JSON.parse(sessionStorage.getItem("history"));

        historyArr.forEach((item) => {
            store.dispatch("addToHistory", { name: item.name, id: parseInt(item.id), path: item.path });
        });
    }

    if(to) {
        if(to.params && to.params.id) {
            store.dispatch("addToHistory", { name: to.name, id: parseInt(to.params.id), path: to.path });
        } else {
            store.dispatch("addToHistory", { name: to.name, id: window.__pageSettings.id, path: to.path });
        }

        sessionStorage.setItem("history", JSON.stringify(store.getters.getHistory));
    }
});

export default router;
